/* tslint:disable */

/**
 * The type of the carrier's vehicle:
 *   * CITERN : CITERN
 *   * TRACTOR : TRACTOR
 */
type VehicleType =
  'CITERN' |
  'TRACTOR';
namespace VehicleType {
  export const CITERN: VehicleType = 'CITERN';
  export const TRACTOR: VehicleType = 'TRACTOR';
  export function values(): VehicleType[] {
    return [
      CITERN,
      TRACTOR
    ];
  }
}

export { VehicleType }